/**
 * ChatPage Component
 * Modern chat interface matching the mockup design
 * - Full-height layout within DashboardLayout
 * - Optional conversation sidebar (toggleable)
 * - Main chat area with hero section and messages
 */
import React, { useState } from "react";
import { ChatInterface } from "../components/chat/ChatInterface";
import { ChatSidebar } from "../components/chat/ChatSidebar";
import { MessageSquare, X } from "lucide-react";

export const ChatPage: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-full bg-[#0a1120]">
      {/* Conversation List Toggle Button */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className={`fixed top-20 z-50 p-2.5 rounded-lg transition-all shadow-lg ${
          sidebarOpen
            ? "left-[330px] bg-slate-800 border border-slate-700 text-white"
            : "left-4 bg-[#1a2b4b] border border-[#2d4a7c] text-blue-400 hover:text-white hover:bg-[#2d4a7c]"
        }`}
        title={sidebarOpen ? "Close conversations" : "View conversations"}
      >
        {sidebarOpen ? <X className="w-5 h-5" /> : <MessageSquare className="w-5 h-5" />}
      </button>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Left Sidebar - Conversation List (Slide-in Panel) */}
      <div
        className={`
          fixed inset-y-0 left-0 z-40
          w-80 flex-shrink-0 transform transition-transform duration-300 ease-in-out
          border-r border-[#2d4a7c]/50 shadow-2xl
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        <ChatSidebar onSelectSession={() => setSidebarOpen(false)} />
      </div>

      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <ChatInterface />
      </div>
    </div>
  );
};
